import { noop } from "lodash";
import $ from "vendors/zepto";
import type {
  AjaxCompleteCallback,
  AjaxErrorCallback,
  AjaxSuccessCallback,
  QueryParameters
} from "types";

/**
 * AJAX GET call.
 *
 * should_use_cache: a `_=[TIMESTAMP]` will be appended to `url` if
 *    `should_use_cache` is set to `false`, which will bust our server side
 *    cache mechanism.
 */
export function get(
  url: string,
  params: QueryParameters = {},
  success_callback: AjaxSuccessCallback,
  error_callback: AjaxErrorCallback = noop,
  complete_callback: AjaxCompleteCallback = noop,
  dataType: "xml" | "html" | "json" | "jsonp" | "text" = "json",
  should_use_cache: boolean = false
): window.XMLHttpRequest {
  return $.ajax({
    type: "GET",
    url: url,
    cache: should_use_cache,
    dataType: dataType,
    data: params,
    success: success_callback,
    crossDomain: true, // To avoid sending `X-Requested-With` header,
    error: error_callback,
    complete: complete_callback
  });
}

export function post(
  url: string,
  payload: QueryParameters = {},
  success_callback: AjaxSuccessCallback,
  error_callback: AjaxErrorCallback = noop,
  complete_callback: AjaxCompleteCallback = noop
): window.XMLHttpRequest {
  return $.ajax({
    type: "POST",
    url: url,
    data: JSON.stringify(payload),
    contentType: "application/json;charset=UTF-8",
    success: success_callback,
    error: error_callback,
    complete: complete_callback
  });
}

export function request(
  url: string,
  action: "PUT" | "DELETE",
  success_callback: AjaxSuccessCallback
): window.XMLHttpRequest {
  return $.ajax({
    type: action,
    url: url,
    contentType: "application/json;charset=UTF-8",
    success: success_callback
  });
}
